import React,{ useState} from 'react';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2'

const MyForm = () => {
  const[nome,setNome] = useState('');
  const[titulo,setTitulo] = useState('');
  const[conteudo,setConteudo] = useState('');
  const[email,setEmail] = useState('');


  const handleSubmit = (event) => {
    event.preventDefault();
    axios({
      method: 'post',
      url: 'https://docs.google.com/forms/u/2/d/e/1FAIpQLSfSAHaQPeVjKHCVKmP_XndVwIeNG4aqcEZXm1ir0JbsFPcatQ/formResponse',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: {
        "entry.637541173": nome,
        "entry.489926244": titulo,
        "entry.1278798230": conteudo,
        "entry.1395040391": email
      }
    })
    .then(x=>{console.clear()})
    .catch(error => {
      if(error.name !== "AxiosError"){
        alert('Desculpe, no momento nao foi possivel enviar seu email.\n'
        ,'Contacte o desenvolvedor do site. No seguinte e-mail:jefferson.maxwell1603@gmail.com')
      }
      Swal.fire({
        title: "Mensagem Enviada!",
        text: 'Espere o contato de volta',
        confirmButtonText: "OK",
        icon:"success",
        color:"var(--cor-secundaria)",
        background:"var(--cor-primaria)",
        confirmButtonColor:"#E20000"
      })
      setNome('');
      setEmail('');
      setTitulo('');
      setConteudo('');
      console.clear();
      setTimeout(()=>{console.clear()},60);
    })


  };

  return (
    <Form onSubmit={handleSubmit}>

      <Form.Group controlId="formName">
        <Form.Label style={{ color: 'red' }}>Nome:</Form.Label>
        <Form.Control 
        type="text" 
        value={nome} 
        name="entry.950355372"
        onChange={x => {setNome(x.target.value)}} 
        placeholder="Insira seu nome" required validated/>
      </Form.Group>

      <Form.Group controlId="formEmail">
        <Form.Label style={{ color: 'red' }}>E-mail para contato:</Form.Label>
        <Form.Control 
        type="email" 
        name="entry.635284895"
        value={email} 
        onChange={x => {setEmail(x.target.value)}} 
        placeholder="Insira seu email" required validated/>
      </Form.Group>

      <Form.Group controlId="formTitle">
        <Form.Label style={{ color: 'red' }}>Título do Mensagem:</Form.Label>
        <Form.Control 
        type="text" 
        name="entry.1493349360"
        value={titulo} 
        onChange={x => {setTitulo(x.target.value)}} 
        placeholder="Insira o título da mensagem." required validated/>
      </Form.Group>

      <Form.Group controlId="formTextarea">
        <Form.Label for="message" style={{ color: 'red' }}>Mensagem:</Form.Label>
        <Form.Control 
        as="textarea" 
        name="emailAddress"
        rows="3" 
        value={conteudo} 
        onChange={x => {setConteudo(x.target.value)}} 
        placeholder="Insira sua mensagem" required validated/>
      </Form.Group>

      <br/>

      <Button size='lg' style={{ display: 'block', margin: '0 auto' }} 
      type="submit" variant='outline-danger'
      
      >
        Enviar
      </Button>

    </Form>
  );
};

export default MyForm;